import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { UserWebvoucherViewModel } from "../../shared/models/userInfo.model";
import { WebVoucherNumberLength } from "../../shared/models/web_voucher.model";

@Component({
  selector: "bonusWebvocherDialog",
  templateUrl: "./bonusWebvocherDialog.component.html",
  styleUrls: ["./bonusWebvocherDialog.component.scss"]
})
export class BonusWebvocherDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  public webVoucherNo: string;

  constructor(public bottomSheetRef: MatBottomSheetRef<BonusWebvocherDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public userWebvoucherViewModel: UserWebvoucherViewModel) {
  }

  ngOnInit() {
    const me = this;
    // die Felder des ViewModels sind nicht initialisiert und koennen undefined sein
    const webvoucherNumber = me.userWebvoucherViewModel && me.userWebvoucherViewModel.webvoucherNumber
      ? me.userWebvoucherViewModel.webvoucherNumber.trim()
      : "";
    if (webvoucherNumber.length === WebVoucherNumberLength) {
      me.webVoucherNo = webvoucherNumber;
    }
  }

  async ngAfterViewInit(): Promise<void> { }

  async ngOnDestroy(): Promise<void> { }

  public OpenWebVoucherModal() {
    const me = this;
    // true to open another modal after closing this one
    me.bottomSheetRef.dismiss(true);
  }
}
